module.exports = "/images/EPtoSHOP.gif";